import { DATA_TEST, ROUTES } from '@/constants'
import router from '@/router'
import * as types from '@/store/mutation-types'

// defining our own error class so we can identify it
class GenericSamwellError extends Error {
  constructor(message) {
    super(message)
    this.name = 'GenericSamwellError'
  }
}

const errorHandlingMap = {
  401: ({ dispatch, commit, state }, { response }) => {
    dispatch('setLookupSessionIdFromHeader', response)
    if (state.interceptUnauthorizedError) {
      commit(types.SET_SESSION_EXPIRED_NOTICE, true)
      dispatch('stopAllLoaders')
      // returning a generic error to stop code execution at this point ~ Inkh
      throw new GenericSamwellError('RESOLVED_UNAUTHENTICATED_ERROR')
    }
  },

  403: ({ dispatch, commit }, { response }) => {
    const { data } = response
    const isLocked = data && data.status === 'LOCKED'
    if (!isLocked) return

    dispatch('setMessagePageContent', {
      buttonText: 'button.ok',
      errorId: `${DATA_TEST.ERROR}-account-locked`,
      header: 'verification.accountLocked',
      message: 'verification.contactUs'
    })

    commit(types.SET_SESSION_EXPIRED_NOTICE, false)
    dispatch('stopAllLoaders')

    router.replace({
      name: ROUTES.ERROR,
      params: { logout: true }
    })
    // returning a generic error to stop code execution at this point ~ Inkh
    throw new GenericSamwellError('LOCK_FORBIDDEN_ERROR')
  }
}

export default errorHandlingMap
